import { FC, PropsWithChildren, useReducer, useState } from "react";
import { LocatorConfigurationContext, locatorConfigurationReducer } from "./";
import {
  InterfaceConfiguration,
  InterfaceConfigurationParameters,
} from "../../interfaces";
import { getInterfaceConfig } from "../../services/restInterfaceConfiguration";
import { fixRelativePath } from "../../utils/bullseyeUtils";
import { GEOCODING_SERVICE } from "../../utils/constants";

export interface LocatorConfigurationState {
  interfaceInternalConfiguration: {} | null;
  locatorConfigurationIsLoading: boolean;
  interfaceConfiguration: InterfaceConfiguration | null;
  interfaceNotFound: boolean;
}

const LocatorConfiguration_INITIAL_STATE: LocatorConfigurationState = {
  interfaceInternalConfiguration: null,
  locatorConfigurationIsLoading: true,
  interfaceConfiguration: null,
  interfaceNotFound: false,
};

export const LocatorConfigurationProvider: FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(
    locatorConfigurationReducer,
    LocatorConfiguration_INITIAL_STATE
  );

  const setLocatorConfiguration = async ({
    interfaceName,
    apiKeyName,
    language,
    interfaceId,
  }: InterfaceConfigurationParameters) => {
    const configuration = await getInterfaceConfig(
      interfaceName,
      apiKeyName,
      language,
      interfaceId
    );

    if (!configuration) {
      dispatch({
        type: "[LocatorConfiguration] - SetConfigurationError",
      });
    } else {
      dispatch({
        type: "[LocatorConfiguration] - SetConfiguration",
        payload: configuration,
      });
    }
  };

  return (
    <LocatorConfigurationContext.Provider
      value={{
        ...state,
        setLocatorConfiguration,
      }}
    >
      {children}
    </LocatorConfigurationContext.Provider>
  );
};
